import { attr } from '@ember-data/model';
import CatalogFragment from '@square/dashboard-items-data/models/connect/catalog-fragment';
export default CatalogFragment.extend({
  name: attr('string'),
  displayName: attr('string'),
  description: attr('string'),
  showColors: attr('boolean', {
    allowNull: true,
    defaultValue: false
  }),
  itemCount: attr('number', {
    defaultValue: 0
  })
}).reopenClass({
  _modelNameForMigration: 'connect/item-option/data'
});